import Loader from '../Loader';
import { Image, Initials, Wrapper } from './wrapper';

export interface AvatarImageProps {
  src: string;
  srcSet?: string;
  alt: string;
}

export type AvatarSizeProps = 'small' | 'large';

export interface AvatarProps {
  initials?: string;
  image?: AvatarImageProps;
  size?: AvatarSizeProps;
  loading?: boolean;
}

const ScopeAvatar = ({ initials, image, size, loading }: AvatarProps) => (
  <Wrapper $size={size} $background={!!initials || loading}>
    {image && <Image src={image.src} srcSet={image.srcSet} alt={image.alt} />}
    {initials && <Initials>{initials}</Initials>}
    {loading && (
      <Initials>
        <Loader inlineBlock />
      </Initials>
    )}
  </Wrapper>
);

export default ScopeAvatar;
